import { createSelector } from 'reselect';
import { FOOTER_MAIN, FOOTER_PRODUCT } from 'swag-client-common/utils/constants';
import { isPreBuiltLimitedCartOpenedByCustomerSelector } from 'swag-client-common/redux/cart/cart.selectors';
import { isResellerInOrderCreationModeSelector } from 'swag-client-common/redux/user/user.selectors';
import { fullScreenModeSelector, productLoadedSelector, isCreateModeSelector, fontsLoadedSelector, isFullDesignProductSelector, productIdSelector, isBoxProductSelector, openedToolbarItemSelector, isOpenRelatedProductsPopup, hasDonateWidgetSelector, isOutOfStockSelector, isLimitedEditionSelector, isAnyLogoUploadedSelector } from '../../../../../redux/product/product.selectors';
import { layersSelector, textsSelector, logosSelector } from '../../../../../redux/logo/logo.selectors';
import { collectSizesLoadingSelector } from '../../../../../redux/collect-sizes/collect-sizes.selectors';
import { isCuratedBrandStoreSelector } from '../../../../../redux/curated-brand-store/curated-brand-store-other.selector';

// find correct place for this checking

export default createSelector([fullScreenModeSelector, productLoadedSelector, isCreateModeSelector, fontsLoadedSelector, layersSelector, isFullDesignProductSelector, isAnyLogoUploadedSelector, textsSelector, logosSelector, productIdSelector, isBoxProductSelector, openedToolbarItemSelector, isOpenRelatedProductsPopup, hasDonateWidgetSelector, isOutOfStockSelector, isLimitedEditionSelector, collectSizesLoadingSelector, isPreBuiltLimitedCartOpenedByCustomerSelector, isResellerInOrderCreationModeSelector, isCuratedBrandStoreSelector], (isFullScreenMode, isProductLoaded, isShareContinueBlockShown, isFontsLoaded, layers, isFullDesignProduct, isMediaUploaded, texts, logos, productId, isBoxProduct, openedToolbarItem, isOpenRelatedProductsPopup, hasDonateWidget, isOutOfStock, isLimitedEdition, collectSizesLoading, isPreBuiltLimitedCart, isResellerInOrderCreationMode, isCuratedBrandStore) => ({
  hasDonateWidget,
  texts,
  logos,
  isOutOfStock,
  layers,
  productId,
  isBoxProduct,
  isMediaUploaded,
  isFullScreenMode,
  isShareContinueBlockShown,
  views: Object.keys(layers),
  openedToolbarItem,
  isProductLoaded: isProductLoaded && isFontsLoaded,
  footer: isFullScreenMode && FOOTER_PRODUCT || FOOTER_MAIN,
  isHiddenSectionShown: isProductLoaded && !isFullDesignProduct,
  isOpenRelatedProductsPopup,
  isLimitedEdition,
  isPreBuiltLimitedCart,
  isResellerInOrderCreationMode,
  loading: collectSizesLoading,
  isCuratedBrandStore
}));